/*/// <reference types="@types/googlemaps" />*/
/// <reference types="@types/google.maps" />

import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import * as moment from 'moment';
import { DialogBase, RentalObjectInfo } from 't4core';

@Component({
    selector: 't4-ServiceBookingDialog',
    templateUrl: 'ServiceBookingDialog.html',
    styleUrls: ['./ServiceBookingDialog.css']
})
export class ServiceBookingDialog extends DialogBase implements OnInit {
    public allDay: boolean = true;
    public startDate: moment.Moment = moment().startOf('day');
    public endDate: moment.Moment = moment().endOf('day');
    public startTime: moment.Moment = moment().startOf('day');
    public endTime: moment.Moment = moment().endOf('day');

  public showDisabled: boolean = false;

    public get serviceStart(): moment.Moment {
        var ret = this.startDate.clone();

        if (!this.allDay) {
            ret.startOf('day');
            ret.hour(this.startTime.hour());
            ret.minute(this.startTime.minute());
            ret.second(0);
        }

        return ret;
    }

    public get serviceEnd(): moment.Moment {
        var ret = this.endDate.clone();
        if (!this.allDay) {
            ret.startOf('day');
            ret.hour(this.endTime.hour());
            ret.minute(this.endTime.minute());
            ret.second(0);
        }
        return ret;
    }

    private selectedObjects: RentalObjectInfo[] = [];

    public get isValid():boolean {
        return this.serviceEnd > this.serviceStart && this.selectedObjects && this.selectedObjects.length > 0;
    }

    constructor(public dialogRef: MatDialogRef<ServiceBookingDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
        super("ServiceBookingDialog");
    }

    public ngOnInit() {
        
    }


  onToggleShowDisabled(event: MatCheckboxChange) {
    this.showDisabled = event.checked;
    if(!this.showDisabled) {
      this.selectedObjects = this.selectedObjects.filter(obj => obj.IsEnabled);
    }
  }

    public objectsChanged(objects: RentalObjectInfo[]) {
        this.selectedObjects = objects;
    }

    public async createServiceBookings() {
        this.loading.dialog = true;
        if (this.isValid) {
            var num = await this.Api.post<number>("RentalObject/CreateServiceBookings", null, {
                fromTime: this.serviceStart.toISOString(),
                toTime: this.serviceEnd.toISOString(),
                objects: this.selectedObjects.filter(obj => this.showDisabled || obj.IsEnabled).map(x => x.Id)
            });

            if (num != this.selectedObjects.length) {
                await this.UI.alert("Turbo.core.ServiceBookingDialog.headSomeFailed", "Some objects could not be booked for service", "Turbo.core.ServiceBookingDialog.hmsgSomeFailed", "This is probably due to them already beeing booked. Move the bookings and try again.");
            }

            this.dialogRef.close();
        }

        this.loading.dialog = false;
    }
}
